import { HttpDashboardService } from './../../../service/http-dashboard.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DashboardV2Dto, ResultListDto } from '../../../service/dto';
import { finalize, Subscription } from 'rxjs';
import { OnTableChange, TableColumn } from '../../../components/table/table.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-dashboard-list',
	standalone: false,
	templateUrl: './dashboard-list.component.html',
	styleUrl: './dashboard-list.component.scss'
})
export class DashboardListComponent implements OnInit, OnDestroy {
	data?: ResultListDto<DashboardV2Dto>;
	pageIndex = 1;
	pageSize = 30;
	appliedFilters: any = {};

	loading = false;
	columnRef: TableColumn[] = [
		{ "title": "ID", "property": "id" },
		{ "title": "Name", "property": "name" },
		{ "title": "Description", "property": "description" },
		{ "title": "Owner", "cellRef": "refOwner" },
		{ "title": "Main", "cellRef": "refMain" }
	];

	constructor(private httpService: HttpDashboardService,private router: Router) {

	}
	ngOnInit(): void {
		this.doFetchResults({pageIndex: this.pageIndex, pageSize: this.pageSize, filters:[]});
	}
	ngOnDestroy(): void {
	}
	doView(input: DashboardV2Dto){
		this.router.navigate(['/dashboard',input.id,'edit']);
	}

	doFetchResults(input: OnTableChange) {
		const appliedFilters = {
			pageIndex: input.pageIndex,
			pageSize: input.pageSize,
		};
		if (JSON.stringify(this.appliedFilters) == JSON.stringify(appliedFilters)) {
			return;
		}
		this.appliedFilters = appliedFilters;

		this.pageIndex = input.pageIndex;
		this.pageSize = input.pageSize;
		this.loading = true;

		this.httpService.getDashboards(this.pageIndex, this.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.data = result;
			});
	}
}
